<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :liveSearching="true"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "name",
      "area",
      "system_class",
      "system_subclass",
      "updated_at",
      "updated_admin",
    ],
    sortBy: "name",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "篩選子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "multiple-layer-select",
        label: "",
        textKey: "name",
        modelName: "system_subclass",
        getUrl: "system_class",
        placeholder: "篩選領域/子領域",
        orderBy: "sequence",
        orderWay: "asc",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "hasMany",
        label: "",
        textKey: "name",
        modelName: "industry_category",
        placeholder: "篩選產業類別",
      },
    ],
  }),
};
</script>

<style>
</style>